<template>
  <card-component class="bfy-column no-padding no-border no-background w-20">
    <b-button
      size="is-large"
      type="is-success"
      icon-left="airplane-takeoff"
      class="change-status-button mb-15"
      :disabled="checkStart"
      :loading="isLoading"
      @click="start(3)"
    >
      Göreve Başla
    </b-button>
    <b-button
      size="is-large"
      type="is-purple"
      class="change-status-button mt-10"
      icon-left="airplane-landing"
      :disabled="checkFinish"
      :loading="isLoading"
      @click="finish(4)"
    >
      Görevi Bitir
    </b-button>
  </card-component>
</template>
<script>
import CardComponent from '@/components/CardComponent'
import TransferDetails from '@/views/TransferDetails'

export default {
  name: 'AdminPanel',
  components: { CardComponent},
  extends: TransferDetails,
  props: {
    transfer: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      isLoading: false,
      isLoadingApproval: false,
    }
  },
  computed: {
    checkStart () {
      return this.transfer.status != 2
    },
    checkFinish () {
      return this.transfer.status != 3
    },
  },
  methods: {
    start (status) {
      if (status == 1 || status == 3 || status == 4) {
        this.isLoadingApproval = true
      }
      
      this.$buefy.dialog.prompt({
        message: 'Başlangıç KM',
        confirmText: 'Başla',
        cancelText: 'İptal',
        inputAttrs: {
          type: 'number',
          placeholder: 'Başlangıç KM',
          value: '0',
          min: 0,
        },
        trapFocus: true,
        onConfirm: (value) => {
          if (isNaN(value) || value < 0) {
            return
          }

          this.$http.put('set-status', {
            id: this.transfer.id,
            start_km: value,
            status,
          }).then(({ data }) => {
            if (data.success) {
              this.transfer.status = data.status

              if (this.isLoadingApproval) {
                this.$buefy.toast.open({
                  message: this.$t('approved'),
                  type: 'is-success',
                  queue: false,
                })
                this.isLoadingApproval = false
              }

              this.$store.commit('boardRefresh', true)
            }
          }).finally(() => {
            this.isLoading = false
          })
        }
      })
    },
    finish (status) {
      if (status == 1 || status == 3 || status == 4) {
        this.isLoadingApproval = true
      }

      this.$buefy.dialog.prompt({
        message: 'Bitiş KM',
        confirmText: 'Bitir',
        cancelText: 'İptal',
        inputAttrs: {
          type: 'number',
          placeholder: 'Bitiş KM',
          value: '0',
          min: 0,
        },
        trapFocus: true,
        onConfirm: (value) => {
          if (isNaN(value) || value < 0) {
            return
          }

          this.$http.put('set-status', {
            id: this.transfer.id,
            end_km: value,
            status,
          }).then(({ data }) => {
            if (data.success) {
              this.transfer.status = data.status

              if (this.isLoadingApproval) {
                this.$buefy.toast.open({
                  message: this.$t('approved'),
                  type: 'is-success',
                  queue: false,
                })
                this.isLoadingApproval = false
              }

              this.$store.commit('boardRefresh', true)
            }
          }).finally(() => {
            this.isLoading = false
          })
        }
      })
    },
  },
}
</script>
